<template>
    <div class="card">
        <slot name="header"></slot>

        <button v-if="onDelete != null" type="button" class="btn-delete" @click="(event) => onDelete(event, account)">
            <svg viewBox="0 0 65 79"><path d="M58.3757 18.7079 2.29688 25.5935 16.7573 77.7198l40.6943-4.9967.9241-54.0152Zm-7.8838-4.422L8.88348 19.3517S4.46082 8.87171 26.8034 5.99615C49.146 3.12059 50.4919 14.2859 50.4919 14.2859Z"/><path fill="#FFFBED" d="m37.5369 48.2091 6.0681-7.7668c.9551-1.2224.7378-2.9922-.4846-3.9472-1.2224-.955-2.9923-.7377-3.9473.4847l-6.0682 7.7667-7.8114-6.1079c-1.228-.9543-2.9923-.7377-3.9529.4854-.9543 1.2279-.7377 2.9922.4854 3.9528l7.8107 6.1023-6.0479 7.7473c-.955 1.2224-.7377 2.9922.4847 3.9473 1.2224.955 2.9922.7377 3.9473-.4847l6.0534-7.748 7.6979 6.0142c1.2224.955 2.9923.7377 3.9473-.4847.9551-1.2224.7378-2.9922-.4846-3.9472l-7.6979-6.0142Z"/></svg>
            <span class="sr-only">Supprimer</span>
        </button>

        <div class="card-thumbnail" v-if="image">
            <img :src="image" width="250" alt="" />
        </div>

        <p class="card-name">{{ label }}</p>

        <div class="card-button">
            <slot name="button"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Card"
    }
</script>

<script setup>
    const props = defineProps({
        'label': String,
        'btnLabel': String,
        'image': String,
        'onDelete': Function,
        'account': Object
    });
</script>
